import { render, staticRenderFns } from "./assignCoHost.vue?vue&type=template&id=34ef0347&scoped=true"
import script from "./assignCoHost.vue?vue&type=script&lang=js"
export * from "./assignCoHost.vue?vue&type=script&lang=js"
import style0 from "./assignCoHost.vue?vue&type=style&index=0&id=34ef0347&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ef0347",
  null
  
)

export default component.exports